import React, { useState } from "react";
import { loginWithEmail } from "../utils/auth";

export default function EmailLoginModal({ open, onClose, onLoggedIn }) {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) { setErr("Please enter a valid email."); return; }
    const user = loginWithEmail(email.trim());
    onLoggedIn?.(user);
    onClose?.();
  };

  return (
    <div className="fixed inset-0 z-[1000] bg-black/40 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl p-6">
        <h2 className="text-xl font-semibold mb-2">Login to Treble Town</h2>
        <p className="text-sm text-gray-600 mb-4">
          Enter a parent email to save progress and unlock premium later. You can also continue as a guest.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            placeholder="parent@example.com"
            className="w-full border rounded-lg px-3 py-2 outline-none focus:ring"
            autoFocus
          />
          {err && <div className="text-red-600 text-sm">{err}</div>}
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg border">Cancel</button>
            <button type="submit" className="px-4 py-2 rounded-lg bg-amber-400 hover:bg-amber-300 font-medium">
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
